import { REQUEST_TYPE } from '@/constants/request-types';

import fetchData from './fetchData';

export const fetchUserDetails = async (
    BASE_URL: string | undefined,
    server_id?: string | undefined,
) => {
    if (!server_id || !BASE_URL) return;
    const { data } = await fetchData(
        REQUEST_TYPE.GET,
        `${BASE_URL}api/v1/me/${server_id}`,
    );
    return data;
};
